import React, { Component } from 'react';
import sendErrorToSentry from '../utils/sentry';

interface State {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  onError?: () => void;
}

export class Boundary extends Component<ErrorBoundaryProps> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state: State = {
    hasError: false,
  };

  componentDidCatch(error: Error, errorInfo: any) {
    const { onError } = this.props;
    sendErrorToSentry(error, errorInfo);
    if (onError) {
      onError();
    }
  }

  render() {
    if (this.state.hasError) {
      return <div></div>;
    }
    return this.props.children;
  }
}
